import { render, staticRenderFns } from "./aduditionLessonStudent.vue?vue&type=template&id=1e32804e&scoped=true"
import script from "./aduditionLessonStudent.vue?vue&type=script&lang=js"
export * from "./aduditionLessonStudent.vue?vue&type=script&lang=js"
import style0 from "./aduditionLessonStudent.vue?vue&type=style&index=0&id=1e32804e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32804e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e32804e')) {
      api.createRecord('1e32804e', component.options)
    } else {
      api.reload('1e32804e', component.options)
    }
    module.hot.accept("./aduditionLessonStudent.vue?vue&type=template&id=1e32804e&scoped=true", function () {
      api.rerender('1e32804e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/aduditionLessonStudent.vue"
export default component.exports